import script from "./CampaignPublicPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignPublicPage.vue?vue&type=script&setup=true&lang=js"

import "./CampaignPublicPage.vue?vue&type=style&index=0&id=fac024da&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fac024da"]])

export default __exports__